module.exports = __webpack_public_path__ + "img/type4.9dd19068.png";